export default {
    shipping: [],
    billing: [],
};
